import { CopyOutlined, MoreOutlined } from "@ant-design/icons";
import { Popover, List, Typography, Button, Col, Row, Tag, Badge } from "antd";
import DynamicModal from "../../commonComponents/DynamicModal/DynamicModal";
import ModelOccasions from "./ModelOccasions";
import React, { useState } from "react";
import "./modelList.scss";
const { Text, Link } = Typography;
const ModelListCard = (props) => {
  const [openOccasionModal, setOpenOccasionModal] = useState(false);
  const handleAction = () => {
    setOpenOccasionModal(true);
  };
  const handleOccasionsModal = () => {
    props.refetchModels();
    setOpenOccasionModal(false);
  };
  return (
    <div>
      <div className="model_container">
        <Badge.Ribbon
          text={props?.isPublic ? "Public" : "Private"}
          color={props?.isPublic ? "#8096f1" : "cyan"}
        >
          <img
            className="model_baseFace"
            src={props?.baseFace?.thumbPath?.url}
          />
        </Badge.Ribbon>
        <Typography className="card_subtitle">{props?.name}</Typography>
        <Button
          className="view_details_btn"
          // style={{ backgroundColor: props?.isPublic ? "#8096f1" : "#13c2c2" }}
          onClick={handleAction}
        >
          View Details
        </Button>
      </div>
      {openOccasionModal && (
        <DynamicModal
          open={openOccasionModal}
          closable={true}
          close={() => setOpenOccasionModal(false)}
          footer={null}
          width={750}
          title={`Model Occasions: ${props.name}`}
          component={
            <ModelOccasions
              baseFace={props.baseFace}
              name={props.name}
              isPublic={props.isPublic}
              modelId={props.modelId}
              closeModal={handleOccasionsModal}
            />
          }
        />
      )}
    </div>
  );
};

export default ModelListCard;
